/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-10-09 10:02:35
 */
import React, { useEffect } from "react";
import { Navigate, useLocation, useRoutes } from "react-router-dom";
import { RouteObject } from "@/routers/interface";

import Login from "@/pages/User/login/index";
import Register from "@/pages/User/Register";
import FindPassword from "@/pages/User/FindPassword";
import EmailValidate from "@/pages/User/EmailValidate";
import ReactGA from "react-ga4";

// * 导入所有router
const metaRouters = import.meta.globEager("./modules/*.tsx");

const home = import.meta.globEager("./modules/home.tsx");
const AdAccount = import.meta.globEager("./modules/AdAccount.tsx");
const AutomatedRules = import.meta.globEager("./modules/AutomatedRules.tsx");
const AdManagement = import.meta.globEager("./modules/AdManagement.tsx");
const AssertOperation = import.meta.globEager("./modules/AssetOperation.tsx");
const error = import.meta.globEager("./modules/error.tsx");
const team = import.meta.globEager("./modules/team.tsx");
const copyCamapignRouter = import.meta.globEager("./modules/CopyCampaign.tsx");
const Subscription = import.meta.globEager("./modules/Subscription.tsx");
const AccountSettingModal = import.meta.globEager("./modules/accountSetting.tsx");
const Admenergement = import.meta.globEager("./modules/admenergement.tsx");
const Data = import.meta.globEager("./modules/data.tsx");

export let routerArray: RouteObject[] = [];

[
	...Object.keys(home),
	...Object.keys(AdAccount),
	...Object.keys(AutomatedRules),
	...Object.keys(AdManagement),
	...Object.keys(AssertOperation),
	...Object.keys(error),
	...Object.keys(team),
	// ...Object.keys(copyCamapignRouter),
	...Object.keys(Subscription),
	...Object.keys(AccountSettingModal),
	...Object.keys(Admenergement),
	...Object.keys(Data)
].forEach(item => {
	Object.keys(metaRouters[item]).forEach((key: any) => {
		routerArray.push(...metaRouters[item][key]);
	});
});

export const rootRouter: RouteObject[] = [
	{
		path: "/",
		element: <Navigate to="/login" />
	},
	{
		path: "/login",
		element: <Login />,
		meta: {
			requiresAuth: false,
			title: "登录页",
			key: "login"
		}
	},
	{
		path: "/register",
		element: <Register />,
		meta: {
			requiresAuth: false,
			title: "注册页",
			key: "Register"
		}
	},
	{
		path: "/FindPassword",
		element: <FindPassword />,
		meta: {
			requiresAuth: false,
			title: "找回密码",
			key: "FindPassword"
		}
	},
	{
		path: "/EmailValidate",
		element: <EmailValidate />,
		meta: {
			requiresAuth: false,
			title: "邮箱校验",
			key: "EmailValidate"
		}
	},

	...routerArray,

	{
		path: "*",
		element: <Navigate to="/home/index" />
	}
];

const Router = () => {
	let location = useLocation();
	useEffect(() => {
		const path = location.pathname;
		console.log("Send pageview:", path);
		ReactGA.send({ hitType: "pageview", page: path });
	}, [location]);

	const routes = useRoutes(rootRouter);
	return routes;
};

export default Router;
